module.exports = __webpack_public_path__ + "mobile-format-2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-start/assets/mobile-format-2.mp4
// module id = 1168
// module chunks = 10